// extracted by mini-css-extract-plugin
export default {"card":"style_card__M4moi","fix":"style_fix__pmJP4","content":"style_content__mRApP","item":"style_item__jVZ3+","eye":"style_eye__AdgCS"};